function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_48_7463)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7381 19C10.7503 17.5129 9.97127 15.9225 9.03165 14.335C8.14775 12.8417 6.90822 11.3674 6.32524 9.76718C5.10495 6.41762 7.49651 3.45281 10.5352 3.06124C14.2356 2.58444 17.4398 4.9289 16.9504 8.79531C16.714 10.663 15.3362 12.423 14.4445 14.0434C13.5168 15.7291 12.5532 17.2936 11.7381 19ZM8.93141 8.01781C8.88891 10.8822 13.8744 11.0103 14.0435 8.21218C14.1474 6.49498 12.6138 5.65829 10.9362 5.97687C9.79165 6.19428 8.94915 6.82182 8.93141 8.01781Z",
  fill: "#0079A4"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_48_7463"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24
})));

function SvgContainerTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerTracking);
export default __webpack_public_path__ + "static/media/container_tracking.1b05ae73.svg";
export { ForwardRef as ReactComponent };